import { LanguageCode } from 'common/src/vtj/LanguageCode.enum'
import { SyntymapaikkaVTJ } from 'todistukset-common/src/vtj/vtj-kysely/aetpohja-soap-response-converter'

export const selectBirthPlaceByLang = (
  birthPlace: SyntymapaikkaVTJ,
  lang: LanguageCode
): string | null => {
  if (!birthPlace.kotimainen.fi && !birthPlace.kotimainen.sv) {
    return birthPlace.ulkomainen
  }
  if (lang === LanguageCode.SV) {
    return birthPlace.kotimainen.sv || birthPlace.kotimainen.fi
  } else {
    return birthPlace.kotimainen.fi || birthPlace.kotimainen.sv
  }
}
